import {Component, OnInit} from '@angular/core';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {AuthService} from '../auth.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  errorMsg: string;

  constructor(private authService: AuthService, private router: Router) {
  }

  ngOnInit() {
  }

  login() {
    this.authService.login(this.username, this.password).pipe(
      tap(() => this.router.navigate(['dashboard'])),
      catchError(err => {
        return this.errorMsg = 'Invalid username or password'})
    ).subscribe()
  }

  googleLogin() {
    this.authService.sendToLogin(`${window.location.origin}`);
  }

}
